(function(){
  'use strict';
  /* scroll reveal */
  function reveal(){
    var els=[].slice.call(document.querySelectorAll('.ksa-reveal:not(.is-visible)'));
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-visible')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-visible');io.unobserve(x.target);}})},{threshold:.12});
    els.forEach(function(e){io.observe(e)});
  }
  /* hero slider */
  function hero(root){
    if(root.__ksa)return;root.__ksa=1;
    var slides=[].slice.call(root.querySelectorAll('.ksa-hero__slide'));
    if(slides.length<2){return;}
    var dotsWrap=root.querySelector('.ksa-hero__dots'),i=0,t,auto=root.dataset.autoplay==='true',speed=parseInt(root.dataset.speed,10)||5000;
    var dots=slides.map(function(_,n){var b=document.createElement('button');b.setAttribute('aria-label','Slide '+(n+1));b.onclick=function(){go(n,true)};dotsWrap.appendChild(b);return b;});
    function go(n,user){slides[i].classList.remove('is-active');dots[i].classList.remove('is-active');i=(n+slides.length)%slides.length;slides[i].classList.add('is-active');dots[i].classList.add('is-active');if(user)restart();}
    function restart(){clearInterval(t);if(auto)t=setInterval(function(){go(i+1)},speed);}
    var p=root.querySelector('.prev'),n=root.querySelector('.next');
    if(p)p.onclick=function(){go(i-1,true)};if(n)n.onclick=function(){go(i+1,true)};
    var sx=0;root.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    root.addEventListener('touchend',function(e){var d=e.changedTouches[0].clientX-sx;if(Math.abs(d)>40)go(i+(d<0?1:-1),true)});
    dots[0].classList.add('is-active');restart();
  }
  /* daily countdown (resets every day at midnight, KSA time UTC+3) */
  function countdown(){
    var boxes=document.querySelectorAll('[data-ksa-countdown]');
    if(!boxes.length)return;
    function tick(){
      var off=3*3600000,now=Date.now()+off,end=Math.floor(now/86400000)*86400000+86400000,s=Math.max(0,Math.floor((end-now)/1000));
      var v=[Math.floor(s/3600),Math.floor(s%3600/60),s%60].map(function(x){return String(x).padStart(2,'0')});
      boxes.forEach(function(b){var n=b.querySelectorAll('b');if(n.length>=3){n[0].textContent=v[0];n[1].textContent=v[1];n[2].textContent=v[2];}});
    }
    tick();setInterval(tick,1000);
  }
  function init(){reveal();document.querySelectorAll('.ksa-hero').forEach(hero);countdown();}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
